import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  editOppTeam,
  getOneOppTeam,
  deleteOppTeam,
} from "../../services/team.services.js";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { isValidEmail } from "../../utils/helper.js";
import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay.js";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay";
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";

const initialState = {
  teamName: "",
  teamNickName: "",
  teamOwner: "",
  coachName: "",
  coachCell: "",
  coachEmail: "",
  isConference: true,
};

const EditOppTeam = () => {
  const history = useHistory();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);

  const { team_id: tid } = location.state || {};
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [getTeamLoading, setGetTeamLoading] = useState(false);
  const [displayPhone, setDisplayPhone] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [updateTeamLoader, setUpdateTeamLoader] = useState(false);
  const [error, setError] = useState(null);
  const [successVisible, setSuccessVisible] = useState(false);
  const [delIsVisible, setDelIsVisible] = useState(false);
  const [delLoading, setDelLoading] = useState(false);
  const [delSuccessVisible, setDelSuccessVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const goBackHandler = () => {
    history.goBack();
  };


  useEffect(() => {
    handleFormChange("teamId", tid);
    (async () => {
      try {
        setGetTeamLoading(true);
        const response = await getOneOppTeam(tid, user?.token);
        const {
          teamName,
          teamNickName,
          coachCell,
          coachEmail,
          coachName,
          isConference,
          teamOwner,
        } = response.data;
        handleFormChange("teamName", teamName);
        handleFormChange("teamNickName", teamNickName);
        handleFormChange("coachCell", coachCell);
        handleFormChange("coachEmail", coachEmail);
        handleFormChange("coachName", coachName);
        handleFormChange("isConference", isConference);
        handleFormChange("teamOwner", teamOwner);
      } catch (e) {
        console.error("Error fetching team details", e);
      } finally {
        setGetTeamLoading(false);
      }
    })();
  }, [tid, user?.token]);

  useEffect(() => {
    const phoneLength = initialStateForm.coachCell.length;
    let formattedNumber = "";

    if (phoneLength < 4) {
      formattedNumber = initialStateForm.coachCell;
    } else if (phoneLength > 3 && phoneLength < 7) {
      formattedNumber = `(${initialStateForm.coachCell.slice(
        0,
        3
      )}) ${initialStateForm.coachCell.slice(3)}`;
    } else {
      formattedNumber = `(${initialStateForm.coachCell.slice(
        0,
        3
      )}) ${initialStateForm.coachCell.slice(
        3,
        6
      )}-${initialStateForm.coachCell.slice(6, 12)}`;
    }

    setDisplayPhone(formattedNumber);
  }, [initialStateForm.coachCell]);

  const handleUpdate = async () => {
    try {
      if (
        initialStateForm.coachEmail &&
        !isValidEmail(initialStateForm.coachEmail)
      ) {
        throw new Error("Invalid email format!");
      }
      setUpdateTeamLoader(true);
      await editOppTeam(initialStateForm, user?.token);
      setSuccessVisible(!successVisible);
      setTimeout(() => {
        history.goBack();
      }, 2500);
    } catch (e) {
      setError(e);
    } finally {
      setUpdateTeamLoader(false);
    }
  };


  const handleDeleteTeam = async () => {
    try {
      setDelLoading(true);
      await deleteOppTeam(tid, user?.token);
      toggleDelSuccessModal();
      setTimeout(() => {
        history.push("/");
      }, 2500);
    } catch (e) {
      setError(e);
    } finally {
      setDelLoading(false);
    }
  };

  const toggleDelSuccessModal = () => {
    setDeleteVisible(false);
    setDelSuccessVisible(!delSuccessVisible);
    setTimeout(() => {
      history.push("/opponents");
      setDelSuccessVisible(false);
    }, 2500);
  };

  const toggleSuccessModal = () => {
    setSuccessVisible(!successVisible);
    setTimeout(() => {
      history.push("/opproster");
      setSuccessVisible(false);
    }, 2500);
  };
  const toggleDelete = () => setDelIsVisible(!delIsVisible);
  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="editTeam-container">
      <UserSidebar />
      {/* Error Overlay */}
      <ErrorOverlay
        onBackdropPress={() => setError(null)}
        visible={!!error}
        error={error}
      />

      <div className="editTeam-content">
        {/* Header */}
        <div className="editTeam-header">
          <h1 className="editTeam-title">Edit Team</h1>
          <button onClick={handleDeleteTeam} className="delete-btn">
            <DeleteOutlineIcon sx={{ fontSize: 28 }} />
          </button>
        </div>

        {/* Form */}
        <form className="editTeam-form">
          <div className="form-row">
            <div className="form-group">
              <label>Team Name:</label>
              <input
                placeholder="Team Name"
                value={initialStateForm.teamName}
                onChange={(e) => handleFormChange("teamName", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Team Nickname:</label>
              <input
                placeholder="Team Nickname"
                value={initialStateForm.teamNickName}
                onChange={(e) =>
                  handleFormChange("teamNickName", e.target.value)
                }
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Coach Name:</label>
              <input
                placeholder="Coach Name"
                value={initialStateForm.coachName}
                onChange={(e) => handleFormChange("coachName", e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Coach Cell#:</label>
              <input
                placeholder="Coach contact number"
                value={isFocused ? initialStateForm.coachCell : displayPhone}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(e) => handleFormChange("coachCell", e.target.value)}
              />
            </div>
          </div>

            <div className="form-group">
              <label>Coach Email:</label>
              <input
                placeholder="Coach email"
                value={initialStateForm.coachEmail}
                onChange={(e) => handleFormChange("coachEmail", e.target.value)}
              />
            </div>

          <div className="form-group">
            <label>Conference</label>
            <input
              type="checkbox"
              checked={initialStateForm.isConference}
              onChange={() =>
                handleFormChange("isConference", !initialStateForm.isConference)
              }
            />    
          </div>

          {/* Actions */}
          <div className="form-actions">
            <button
              type="button"
              onClick={goBackHandler}
              className="cancel-btn-editTeam"
            >
              Cancel
            </button>
            <button type="button" onClick={handleUpdate} className="save-btn-editTeam">
              {updateTeamLoader ? "Saving..." : "Save"}
            </button>
          </div>
        </form>

        {successVisible && (
          <SuccessOverlay
            onBackdropPress={() => setSuccessVisible(false)}
            isVisible={successVisible}
            type="Team has been edited successfully!"
          />
        )}
      </div>
    </div>
  );
}

export default EditOppTeam;